<script>
	import { link, navigate } from "svelte-navigator";

    export let routeId;
    export let title;
</script>

<div class="node-icon visited" on:click="{() => navigate(routeId)}">
    <span class="node-icon-connector active"></span>
    <svg class="svg-tick-icon" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
    </svg>
</div>
<a use:link class="tracker-node-title" href="{routeId}">{title}</a>

<style>
    a.tracker-node-title {
        font-size: 0.8571428571428571rem;
        font-weight: 400;
        line-height: 1.5;
        margin: 0;
        color: #212529;
        text-decoration: none;
    }

        a.tracker-node-title:hover {
            text-decoration: underline;
        }

</style>